import * as zod from 'zod';

/**
 * Persisted subset of the frontend DashboardState. UI-only fields
 * (activeTabKind, editMode) live in the frontend state and are not stored.
 */

export const GridPositionSchema = zod.object({
  col: zod.number().int().min(0),
  row: zod.number().int().min(0),
});

export const GridSizeSchema = zod.object({
  w: zod.number().int().min(1),
  h: zod.number().int().min(1),
});

export const WidgetPlacementSchema = zod.object({
  id: zod.string(),
  type: zod.string(),
  position: GridPositionSchema,
  size: GridSizeSchema,
  config: zod.record(zod.unknown()),
});

export const DashboardSchema = zod.object({
  id: zod.string(),
  routineIds: zod.array(zod.string()),
  layout: zod.array(WidgetPlacementSchema),
});

export const RobotDashboardData = zod.object({
  id: zod.string(),
  robotID: zod.string(),
  dashboardLayout: zod.array(WidgetPlacementSchema),
  routineDashboards: zod.array(DashboardSchema),
  createdAt: zod.string().optional(),
  updatedAt: zod.string().optional(),
});

export type RobotDashboardData = zod.infer<typeof RobotDashboardData>;
